export const LUPP_BASE_URL = import.meta.env.VITE_LUPP_BASE_URL;

export const LUPP_API_BASE_PATH = 'sales/X/v1';
export const IMPORTER_API_BASE_PATH = 'importer/X/v1';

export const LUPP_QUERY_KEYS = {
  INCENTIVES: 'lupp-incentives',
  LEADS: 'lupp-leads',
  PROSPECTS: 'lupp-prospects',
  PROSPECT_METRICS: 'lupp-prospect-metrics',
  PROSPECT_LIST_METADATA: 'lupp-prospect-list-metadata',
  PROSPECTS_EXPORT_HISTORY: 'lupp-prospects-export-history',
  QUOTES: 'lupp-quotes',
  FHM_ALERTS: 'lupp-fhm-alerts',
  FHM_ALERT_DETAIL: 'lupp-fhm-alert-detail',
  FSE_TECH_SUPPORT_CASES: 'lupp-fse-tech-support-cases',
  CUSTOMER_CASES: 'lupp-customer-cases',
  NOTES: 'lupp-notes',
  PARTNER_USERS: 'lupp-partner-users',
  PARTNER_LOCATIONS: 'lupp-partner-locations',
  // FileHub keys
  FILES: 'lupp-files',
  FILE_METADATA: 'lupp-file-metadata',
  // Inventory keys
  INVENTORY_VEHICLES: 'lupp-inventory-vehicles',
  VEHICLE_SEARCH: 'lupp-vehicle-search',
  USER_LOCATION: 'lupp-user-location',
  PR_CODES: 'lupp-pr-codes',
  PRICE_BOOK_PR_CODES: 'lupp-price-book-pr-codes',
  USER_IDENTITY: 'lupp-user-identity',
  // Importer Order Desk keys
  ORDER_NOTIFICATIONS: 'lupp-order-notifications',
  IMPORTER_ORDERS: 'lupp-importer-orders',
  IMPORTER_ORDER_DETAIL: 'lupp-importer-order-detail',
  IMPORTER_ORDER_EVENTS: 'lupp-importer-order-events',
  IMPORTER_ORDER_LINE_ITEMS: 'lupp-importer-order-line-items',
  IMPORTER_ORDER_LINE_ITEM: 'lupp-importer-order-line-item',
  VEHICLE_ORDER: 'lupp-vehicle-order',
  DELIVERIES: 'lupp-deliveries',
  ORDER_DELIVERIES: 'lupp-order-deliveries',
  CHANGE_REQUEST: 'lupp-change-request',
  VEHICLE_ORDER_COMPARISON: 'lupp-vehicle-order-comparison',
  // Order Hub keys
  ORDERS: 'lupp-orders',
  ORDER_DETAILS: 'lupp-order-details',
  PROFORMA_INVOICES: 'lupp-proforma-invoices',
  RETAIL_DELIVERY: 'lupp-order-retail-delivery',
  FINAL_INVOICES: 'lupp-final-invoices',
  DELIVERY_ACCEPTANCE: 'lupp-delivery-acceptance',
  SERVICE_CENTERS: 'lupp-service-centers',
  // D&B Search keys
  DUNS_SEARCH: 'lupp-duns-search',
  PARTS: 'lupp-parts',
  TEST_DRIVE_VEHICLES: 'lupp-test-drive-vehicles',
  TEST_DRIVE_AVAILABLE_SLOTS: 'lupp-test-drive-available-slots',
  PROSPECT_TEST_DRIVES: 'lupp-prospect-test-drives',
  AGENCY_USER_AVAILABILITY: 'lupp-agency-user-availability',
  TEST_DRIVE_BOOKINGS_SEARCH: 'lupp-test-drive-bookings-search',
  SALES_CONSULTANTS_CALENDAR: 'lupp-sales-consultants-calendar',
  // FinOps keys
  LENDERS: 'lupp-lenders',
};
